export interface PlanUnit {
  brId: number;
  typeName: string;
  flags?: Flag[];
  details?: PlanUnitDetail[];
  type: string;
  category?: string;
  categoryName?: string;
  privilegedEmailAddress?: string;
  sortOrderAgency?: string;
  colorCode?: string;
  clusters: Cluster[];
  valid?: Valid;
  brFlags?: Flag[];
  employerId?: number;
  empPool?: EmpPool;
  code?: string;
  name?: string;
  pool?: Pool;
  employerName?: string;
  nameShort?: string;
  employerNameBrief?: string;
  poolName?: string;
  parentBrDynId?: number;
  hierarchy?: string[];
  hideDescendantCount?: boolean;
  collapsed?: boolean;
}
export interface EmpPool {
  id: number;
  name: string;
}

export interface Pool {
  id: number;
  name: string;
}

export interface Cluster {
  clusterName: string;
  clusterId: number;
}

export interface PlanUnitDetail {
  valid: Valid;
  employerId?: number;
  empPoolId?: number;
  code: string;
  name: string;
  poolId?: number;
  employerName?: string;
  nameShort: string;
  employerNameBrief?: string;
  empPoolName?: string;
  poolName?: string;
}

export interface Valid {
  from: string;
  to: string;
}

export enum Flag {
  REQUEST_EXCLUDE = 'REQUEST_EXCLUDE',
  ROOT = 'ROOT'
}

export interface BrCategory {
  code: string;
  groupId: number;
  name: string;
  id: number;
}

export interface BrType {
  code: string;
  groupId: number;
  name: string;
  id: number;
}

export enum PlanUnitLink {
  CLUSTER = 'cluster',
  EMPLOYEE_POOL = 'employeePool',
  REQUEST_POOL = 'requestPool',
  EMPLOYER = 'employer'
}

export interface CostCenterDetail {
  brDynId: number;
  brId: number;
  code: string;
  codeImp: string;
  employerId: 1;
  employerName: string;
  employerNameBrief: string;
  flags: CostCenterDetailFlag[];
  name: string;
  nameShort: string;
  parentBrDynId: number;
  parentBrName: string;
  parentBrNameShort: string;
  poolName: string;
  valid: Valid;
}

export enum CostCenterDetailFlag {
  BUH_BLOCKED = 'BUH_BLOCKED',
  PLANNING_EXPORT = 'PLANNING_EXPORT',
  VAT_DEDUCTIBLE = 'VAT_DEDUCTIBLE',
  INVOICE_DEBIT_BLOCKED = 'INVOICE_DEBIT_BLOCKED',
  INVOICE_CREDIT_BLOCKED = 'INVOICE_CREDIT_BLOCKED',
  ROOT = 'ROOT'
}

export type ParentUnitOption = { brId: number; name: string };
